// extracted by mini-css-extract-plugin
export var animating = "_2s-3";
export var background = "_2s-6";
export var constrainHeight = "_2s-2";
export var dark = "_2s-4";
export var dropdown = "_2s-1";
export var leave = "_2s-5";
export var option = "_2s-7";
export var root = "_2s-0";